import * as React from 'react';
import { I18nContext } from './i18n-provider';

export const useTranslations = () => React.useContext(I18nContext);
